/* eslint-disable no-unused-vars */
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomerGroupList from "./customergroup/CustomergroupList";
import CustomerList from "./CustomerList";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function CustomerHome(props) {
  const { t } = useTranslation();
  const translate = t;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Tabs value={value} onChange={handleChange}>
        <Tab label={translate("Customer")} />
        <Tab label={translate("Customer Group")} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <CustomerList
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CustomerGroupList
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
        />
      </TabPanel>
    </div>
  );
}
